/* eslint-disable no-template-curly-in-string */
export const validateMessages = {
  required: "'${label}' est requis !",
};
